import { configuration } from "@/api/getData";
export default {
  //获取平台配置信息
  getAppidInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      // console.log("hostname", document.location.hostname)
      // 81 test-bylp.81lianpin.com
      // 莲湖 test-lianhu.81lianpin.com
      // 山东 test-sd.81lianpin.com
      // 山西 test-sx.81lianpin.com
      // 天津 test.jyxxztc.com/home
      //本地测试，切换平台
        //let host = 'test.jyxxztc.com'
       // let data = { domain: host }

      //发布线上
      let data = { domain: state.host }
      configuration(data).then(res => {
        if (res.data) {
          commit('updateAppidInfo', res.data)
          resolve(res.data)
        }
      }).catch(err => {
        console.log(err);
      })
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/actions.js